import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Home from '@/views/Home'

function importChildren (r) {
    let homeChildren = []
    let arr = r.keys()
    arr.forEach(file=>{
      let count = file.match(/\//g).length;
      if(count == 2) {
        let path = file.substring(1, file.indexOf('.vue')).toLowerCase()
        let router = {
          path: path,
          component: resolve => require(['@/views/'+file.substring(2)], resolve)
        }
        homeChildren.push(router)
      }
    })

    // console.log('home router', homeChildren)
    return homeChildren
}

Vue.use(Router)

// ignore router replace err
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  let a = originalReplace.call(this, location, () => {
  }, (err) => {
    if(!err){
      // console.log(`err:${err.errmsg}`)
    }
  } )
  return
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: importChildren(require.context('@/views/', true, /\.vue$/)),
    },
    {
      path: '/404',
      component: resolve => require(['@/views/404.vue'], resolve)
    },
    {
      path: '/403',
      component: resolve => require(['@/views/403.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
